/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file The example bar insight component
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-insight-bar[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   .sym-item[_ngcontent-%COMP%]{fill:#f3a357;stroke:#ed7c11}"];
export { styles as styles };
